import React from "react";
import { object } from "prop-types";

import { SectionHeading } from "../";

const SectionAbout = ({ style }) => (
  <div style={style}>
    <SectionHeading title="About" icon="question-circle" />
    <div style={{ padding: "0 8px" }}>
      <a
        href={"https://pdview.com.au/contact"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        Contact us
      </a>
      <br />
      <a
        href={"https://pdview.com.au/about"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        About us
      </a>
      <br />
      <a
        href={"http://pdview.com.au/terms"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        Terms of use
      </a>
    </div>
  </div>
);

SectionAbout.propTypes = {
  style: object
};

export default SectionAbout;



// WEBPACK FOOTER //
// ./src/components/section_about/SectionAbout.jsx